import { Component, OnInit } from '@angular/core';
import { LandingPageService } from '../../../core/services/landing-page.service';
import { Tramite } from '../../../core/interfaces/tramite';

@Component({
  selector: 'dum-tramites',
  templateUrl: './tramites.component.html',
  styleUrls: ['./tramites.component.scss'],
})
export class TramitesComponent implements OnInit {
  tramites: Tramite[];
  // type 0 sin permisos/usuario potencial, sólo web
  // type 1 con permisos/usuario registrado, sólo Android/IOs
  // type 2 sin permisos/usuario registrado, Android/IOS/Web
  tramites1: any;
  tramites2: any;
  tramites3: any;
  constructor(private landingPageService: LandingPageService) {}

  ngOnInit(): void {
    this.tramites = this.landingPageService.getTramites();
    this.tramites1 = this.tramites.filter((tr) => tr.type === 0);
    this.tramites2 = this.tramites.filter((tr) => tr.type === 1);
    this.tramites3 = this.tramites.filter((tr) => tr.type === 2);
  }
}
